

































import {
    myVue
} from "@/components/class/myVue";
import {
    Component
} from 'vue-property-decorator';
import * as utils from "@/components/util/utils";

@Component
export default class HelloWorld extends myVue {
    add() {
        this.current.add()
        // this.current.addData()
    }

    moveIndex(edit_index: any) {
        let newValue: any[] = JSON.parse(this.current.valueFormat())
        if (utils.isNull(newValue)) {
            newValue = utils.lodash.cloneDeep(this.current.value)
        }
        newValue[edit_index] = {
            color: "",
            id: "",
            material_quality: "",
            name: "",
            note: "",
            number: "",
            part_id: "",
            process_part_no: "",
            specifications: "",
            surface_treatment: "",
            url: "[]"
        }
        this.current.value = newValue
    }

    reIndex(edit_index: any) {
        let newValue: any[] = JSON.parse(this.current.valueFormat())
        if (utils.isNull(newValue)) {
            newValue = utils.lodash.cloneDeep(this.current.value)
        }
        utils.lodash.pullAt(newValue, edit_index);
        if (this.current.editMove) {
            let zimu = ["A", "B", "C", "D", "E", "F", "G", "H", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W",
                "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "e", "h", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v",
                "w", "x", "y", "z"]
            for (let index in newValue) {
                let strlength = newValue[index].process_part_no.length - 1
                newValue[index].process_part_no = newValue[index].process_part_no.substring(0, strlength) + zimu[index]
            }
        }
        this.current.value = newValue
    }

    rowClick(row: any, b: any, c: any) {
        this.current.selectRowOnly = row
    }

    cellClick(row: any, column: any, cell: any, event: any, data: any) {
        this.current.selectRowOnly = row
        this.current.cellClick(column)
    }
}
